// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header--3-7-v{align-items:center;background:#6ba038;box-sizing:border-box;color:#fff;display:flex;font-size:32px;justify-content:space-between;margin-bottom:30px;min-height:145px;padding:80px 30px 30px;transition:0.3s padding}.page-header-github--3Gzsc{margin:30px;position:absolute;right:0;top:0;transition:0.2s transform}.page-header-github--3Gzsc path{fill:#fff}.page-header-github--3Gzsc:hover{transform:scale(1.25)}@media only screen and (min-width: 768px) and (min-device-width: 768px){.page-header--3-7-v{padding:30px}.page-header-github--3Gzsc{margin:0;position:relative}}\n", ""]);
// Exports
exports.locals = {
	"page-header": "page-header--3-7-v",
	"page-header-github": "page-header-github--3Gzsc"
};
module.exports = exports;
